import { gsap } from "gsap";

/**
 * ATENA CONSULTING — newsletter.js
 *
 * Stato chiuso:  btn "Iscriviti" visibile, X nascosta
 * Stato aperto:  btn "Iscriviti" sparisce (fade), X appare (fade),
 *                box si espande verso il basso, form fade in
 *
 * Chiusura: click X, click fuori dal box, ESC
 */

const newsletter = () => {

  const CFG = {
    ease:          'power3.inOut',
    durationOpen:  0.55,
    durationForm:  0.45,
    durationClose: 0.4,
    durationFade:  0.25,   // fade cta ↔ close btn
  };

  document.querySelectorAll('[data-newsletter]').forEach(box => {

    const cta      = box.querySelector('.newsletter-box__cta');
    const closeBtn = box.querySelector('.newsletter-box__close');
    const formWrap = box.querySelector('.newsletter-box__form-wrap');

    if (!formWrap) return;

    let isOpen = false;

    // ── Apri ───────────────────────────────────────────
    function open() {
      if (isOpen) return;
      isOpen = true;

      box.classList.add('is-open');
      formWrap.setAttribute('aria-hidden', 'false');

      // 1. Fade out btn "Iscriviti"
      if (cta) {
        gsap.to(cta, {
          opacity:       0,
          duration:      CFG.durationFade,
          ease:          'power2.in',
          pointerEvents: 'none',
        });
      }

      // 2. Fade in ✕ (in alto a destra)
      if (closeBtn) {
        gsap.to(closeBtn, {
          opacity:  1,
          duration: CFG.durationFade,
          delay:    CFG.durationFade * 0.5,
          ease:     'power2.out',
        });
      }

      // 3. Espandi box verso il basso
      gsap.to(formWrap, {
        maxHeight: 600,
        duration:  CFG.durationOpen,
        ease:      CFG.ease,
      });

      // 4. Fade in form
      gsap.to(formWrap, {
        opacity:  1,
        duration: CFG.durationForm,
        delay:    CFG.durationOpen * 0.5,
        ease:     'power2.out',
      });
    }

    // ── Chiudi ─────────────────────────────────────────
    function close() {
      if (!isOpen) return;
      isOpen = false;

      box.classList.remove('is-open');
      formWrap.setAttribute('aria-hidden', 'true');

      // 1. Fade out ✕
      if (closeBtn) {
        gsap.to(closeBtn, {
          opacity:  0,
          duration: CFG.durationFade,
          ease:     'power2.in',
        });
      }

      // 2. Fade in btn "Iscriviti"
      if (cta) {
        gsap.to(cta, {
          opacity:       1,
          duration:      CFG.durationFade,
          delay:         CFG.durationFade * 0.5,
          ease:          'power2.out',
          pointerEvents: 'all',
        });
      }

      // 3. Fade out form
      gsap.to(formWrap, {
        opacity:  0,
        duration: CFG.durationClose * 0.5,
        ease:     'power2.in',
        onComplete: () => {
          // 4. Comprimi box
          gsap.to(formWrap, {
            maxHeight: 0,
            duration:  CFG.durationClose,
            ease:      CFG.ease,
          });
        },
      });
    }

    // ── Listener toggle — sia cta che closeBtn ─────────
    [cta, closeBtn].forEach(btn => {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        isOpen ? close() : open();
      });
    });

    // ── Click outside ──────────────────────────────────
    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (!box.contains(e.target)) close();
    });

    // ── ESC ────────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

  });

};

export default newsletter;